import { render, staticRenderFns } from "./ConfigurationInstitucion.vue?vue&type=template&id=00be208b&"
import script from "./ConfigurationInstitucion.vue?vue&type=script&lang=js&"
export * from "./ConfigurationInstitucion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports